import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbList: PageLink[] = [
  {
    title: 'Propostas',
    path: '/commercial/proposals',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
